import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img
              src="https://customer-assets.emergentagent.com/job_fresh-eats-61/artifacts/1tianodc_ad947667-6ef2-4a6d-a10d-0cf7ca7c8f1a_removalai_preview-2.png"
              alt="Fresh Chicken"
              className="h-16 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <button
              onClick={() => scrollToSection('menu')}
              className="text-black hover:text-red-500 transition-colors duration-200 text-lg font-medium"
            >
              Menu
            </button>
            <button
              onClick={() => scrollToSection('galeria')}
              className="text-black hover:text-red-500 transition-colors duration-200 text-lg font-medium"
            >
              Galeria
            </button>
            <button
              onClick={() => scrollToSection('opinie')}
              className="text-black hover:text-red-500 transition-colors duration-200 text-lg font-medium"
            >
              Opinie
            </button>
            <button
              onClick={() => scrollToSection('kontakt')}
              className="text-black hover:text-red-500 transition-colors duration-200 text-lg font-medium"
            >
              Kontakt
            </button>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden text-black p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <nav className="flex flex-col space-y-4 px-4 py-6">
            <button
              onClick={() => scrollToSection('menu')}
              className="text-black hover:text-red-500 transition-colors duration-200 text-lg font-medium text-left"
            >
              Menu
            </button>
            <button
              onClick={() => scrollToSection('galeria')}
              className="text-black hover:text-red-500 transition-colors duration-200 text-lg font-medium text-left"
            >
              Galeria
            </button>
            <button
              onClick={() => scrollToSection('opinie')}
              className="text-black hover:text-red-500 transition-colors duration-200 text-lg font-medium text-left"
            >
              Opinie
            </button>
            <button
              onClick={() => scrollToSection('kontakt')}
              className="text-black hover:text-red-500 transition-colors duration-200 text-lg font-medium text-left"
            >
              Kontakt
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
